import React, { useMemo, useState } from "react";
import useOptimizeListRenderPerformance from "../useOptimizeListRenderPerformance";
import { BringSearchedToTop } from "Global/Functions/BringSearchedToTop";
import { BringSearhQueryToTop } from "Global/Functions/BringSearhQueryToTop";

const useOptimizedSearchList = (
  largeList,
  length = 15,
  sortTarget,
  SearchQuery = "",
  targetQuery = ""
) => {
  const [listArray, setListArray] = useState([]); // large list will go here because we want to change them
  const [itemsToCompare, setitemsToCompare] = useState([]); // items we want to compare with original array
  const [searchItems, setSearchItems] = useState([]);
  //=============
  useMemo(() => {
    setListArray(largeList);
  }, [JSON.stringify(largeList)]); // since large list is being fetched by API, we set data after fetch
  const { list, handleTouchMove, handleScroll } =
    useOptimizeListRenderPerformance(listArray, null, null, null, length);
  //=============
  useMemo(() => {
    if (itemsToCompare.length > 0 || searchItems.length > 0) {
      setListArray(
        BringSearchedToTop(largeList, itemsToCompare, sortTarget, searchItems)
      );
    }
  }, [JSON.stringify(itemsToCompare), searchItems]);
  //==============
  useMemo(() => {
    if (SearchQuery.length > 0) {
      setSearchItems(
        BringSearhQueryToTop(
          itemsToCompare,
          listArray,
          SearchQuery,
          targetQuery,
          sortTarget
        )
      );
    }
  }, [SearchQuery]);

  return {
    listHandlers: [list, handleScroll, handleTouchMove],
    setitemsToCompare,
  };
};

export default useOptimizedSearchList;

// console.log(
//   " ---- -- --- - - - ->",
//   BringSearhQueryToTop(
//     itemsToCompare,
//     listArray,
//     ArabicToPersian(SearchQuery),
//     targetQuery,
//     sortTarget
//   )
// );
